import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#de_svg__clip0_1486_8201_1)\"><rect y=\"1\" width=\"20\" height=\"18\" rx=\"4\" fill=\"#212121\"></rect><rect y=\"13\" width=\"20\" height=\"6\" fill=\"#FFD748\"></rect><rect y=\"7\" width=\"20\" height=\"6\" fill=\"#E84040\"></rect></g><defs><clipPath id=\"de_svg__clip0_1486_8201_1\"><rect y=\"1\" width=\"20\" height=\"18\" rx=\"4\" fill=\"white\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }